import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import UserInfo from '@ifeng/ui_pc_userInfo';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import Nav from '../../../../components/nav/index';
import ChannelNav from './channelNav/';
import Logo from './logoSearch/';

/**
 * 定义 Header 组件
 */
class Header extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        windowMode: PropTypes.string,
    };

    render() {
        const {
            content: { nav, adTop, channelNav, logo, search, ad_label },
            windowMode,
        } = this.props;

        const logoSearchData = {
            logo,
            search,
            ad_label,
        };

        return (
            <Fragment>
                <div className={`${styles.nav_box} ${windowMode === 'wide' ? styles.wide : null}`}>
                    <div className={styles.main_nav}>
                        <Chip id="20002" type="struct" title="全站导航" groupName="头部" content={nav}>
                            <Nav limit={18} />
                        </Chip>
                        <div className={styles.userinfo}>
                            <UserInfo />
                        </div>
                    </div>
                </div>
                <Ad content={adTop} styleName={styles.ad} />
                <Logo content={logoSearchData} windowMode={windowMode} />
                <Chip id="30059" type="struct" title="频道导航" groupName="头部" content={channelNav}>
                    <ChannelNav windowMode={windowMode} />
                </Chip>
            </Fragment>
        );
    }
}

export default errorBoundary(Header);
